export default __webpack_public_path__ + "assets/images/cup.f10e02.webp";